var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertedPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(90 10 10)",
    fill: "#DFF2E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92308 13L7.25838 8.38462L12.5878 8.38462L9.92308 13Z",
    fill: "#32C36C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedPlay);
export default __webpack_public_path__ + "static/media/invertedPlay.6cdcd8d6fd8e0f58a9dd776d2140eec3.svg";
export { ForwardRef as ReactComponent };